export default __webpack_public_path__ + "static/media/fashionap.0607c326.png";